<div *ngIf="showErrorScreen" class="error-container">
    <img src="../../../assets/img/uniqode-error-img.svg" class="pb-3" alt="uniqode-error-1">
    <h2 class="error-title pb-2">{{ errorTitle }}</h2>
    <p class="error-message pb-4">{{ errorMessage }}</p>
    <button class="error-page-cta" (click)="handleErrorCtaClick()">{{ primaryCtaText }}</button>
</div>
